import { authApiService } from '@/api/authApiService';
import { PaymentDetailsGeneralType } from '@/types/paymentDetailsTypes';
import { ApiResponseType } from '@/types/sharedTypes';

export const getSourceWirePaymentDetailsApi = (wireId: string): Promise<ApiResponseType<PaymentDetailsGeneralType>> => {
  const uri = `/organization/wires/${wireId}/source-wire/payment-details/`;

  return authApiService.GET(uri);
};
